import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../page-names.enum';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';

@Component({
  selector: 'app-cta-link',
  templateUrl: './cta-link.component.html',
  styleUrls: ['./cta-link.component.less']
})
export class CtaLinkComponent extends SelectableNavigationItem implements OnInit, OnDestroy {
  @Output() emitOnEnterPressed = new EventEmitter();
  @Input() omapiId: string;
  
  constructor(private router: Router,
              private navigationService: NavigationService,
              private changeDetector: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, PageNames.DETAIL_PAGE_INTRO);
  }

  activate(active: boolean): void {
    this.active = active;
    this.changeDetector.detectChanges();
  }

  public onBack(): void {
    this.navigationService.resetNavigation();
    this.navigationService.clearNavigation();
    this.routeOnBackPressed();
  }

  private routeOnBackPressed() {
    this.router.navigate(['/'], {queryParamsHandling: 'merge'});
  }

  onEnter(): void {
    this.emitOnEnterPressed.emit(this.omapiId);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
